/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriveFileResource } from '../models/DriveFileResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Rechercher les fichiers d'une entreprise
     * Meme recherche que `GET /v2/drive`, pour n'importe quelle entreprise (`customer_id`), avec en plus un filtre `display_name` (contient). 30 fichiers par page, URLs de telechargement valables 30 minutes.
     * @param requestBody
     * @returns any Paginated set of `DriveFileResource`
     * @throws ApiError
     */
    public driveAdminSearchFiles(
        requestBody: {
            customer_id: number;
            display_name?: string | null;
            entity_type?: 'project' | 'quote' | 'invoice' | 'intervention' | 'bc_fourn';
            entity_id?: number | null;
            tag?: string | null;
            page?: number | null;
        },
    ): CancelablePromise<{
        data: Array<DriveFileResource>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/drive/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Lister les fichiers orphelins d'une entreprise
     * Les fichiers presents dans le stockage de l'entreprise mais qu'aucun enregistrement ne reference. Peut etre long sur un gros volume. Chaque orphelin peut ensuite etre reference (`POST /admin/drive/orphans/register`) ou supprime (`DELETE /admin/drive/orphans`).
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public driveAdminOrphanFiles(
        requestBody: {
            customer_id: number;
        },
    ): CancelablePromise<{
        data: Array<string>;
        total: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/drive/orphans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un fichier orphelin
     * Refuse (422) si le fichier est en fait reference : passer alors par la suppression standard.
     * @param customerId
     * @param fileName
     * @returns any
     * @throws ApiError
     */
    public driveAdminDeleteOrphanFile(
        customerId: number,
        fileName: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/drive/orphans',
            query: {
                'customer_id': customerId,
                'file_name': fileName,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Referencer un fichier orphelin
     * Cree l'enregistrement manquant pour un fichier deja present dans le stockage, avec ses rattachements et tags eventuels.
     * @param requestBody
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveAdminRegisterOrphanFile(
        requestBody: {
            customer_id: number;
            file_name: string;
            display_name: string;
            author_type?: 'personnel' | 'client' | 'user' | 'auto';
            author_id?: number | null;
            tags?: any[] | null;
            attachments?: any[] | null;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/drive/orphans/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Modifier les metadonnees d'un fichier
     * Ne touche pas au fichier lui-meme. `attachments` et `tags`, s'ils sont envoyes, **remplacent** l'existant (envoyer un tableau vide pour tout retirer). Envoyer `author_type: null` vide l'auteur.
     * @param id
     * @param requestBody
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveAdminUpdateFile(
        id: number,
        requestBody?: {
            display_name?: string | null;
            author_type?: 'personnel' | 'client' | 'user' | 'auto';
            author_id?: number | null;
            tags?: any[] | null;
            attachments?: any[] | null;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/drive/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
}
